var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 65.1962,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-60 37 65.1962)",
    fill: "#161616"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1462,
    y: 62.1204,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(90 46.1462 62.1204)",
    fill: "#161616"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4141,
    y: 66.1962,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-120 52.4141 66.1962)",
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0127 37.3381C36.5049 37.3381 36.7854 22.0408 29.5131 22.0408C26.7923 22.0408 25.1674 23.8553 23.7222 26",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0127 22C41.7981 22 39.8398 24.1439 38.2537 26.8159",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 22C22.5079 22 22.2274 37.2973 29.4997 37.2973C32.3624 37.2973 34.012 35.2885 35.5154 33",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 37.3381C17.1089 37.3381 19.0427 35.333 20.6012 32.7842",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0627 36.5L43.0627 23",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4938 37L29.4938 22.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4769 35L25.4769 24",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5107 35L33.5107 24.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6029 37L15.6029 22.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7222 47C25.1674 44.8554 26.7923 43.0408 29.5131 43.0408C34.1794 43.0408 35.7361 49.339 38.5001 53.8528",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 43C22.5079 43 22.2274 58.2973 29.4997 58.2973C32.3624 58.2973 34.012 56.2885 35.5154 54",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14 58.3381C17.1089 58.3381 19.0427 56.333 20.6012 53.7842",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4938 58L29.4938 43.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4769 56L25.4769 45",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5107 56L33.5107 45.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6029 58L15.6029 43.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7096 47C56.1547 44.8553 57.7797 43.0408 60.5004 43.0408C62.1296 43.0408 63.3798 43.8085 64.4346 45",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3394 56.7139C63.3104 57.6686 62.0886 58.2973 60.4871 58.2973C56.0405 58.2973 54.4176 52.5783 51.8829 48.1339",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9073 57.5L59.9073 44",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4137 58L44.4137 43.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3967 56L40.3967 45",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4304 57V44.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0127 58.3381C41.964 58.3381 40.0438 56.3737 38.5001 53.8528",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9875 58.3381C48.0963 58.3381 50.0301 56.333 51.5886 53.7842",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9875 43C48.2933 43 50.2722 45.3096 51.8829 48.134",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0127 43C41.7981 43 39.8398 45.1439 38.2537 47.8159",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndels);
export default __webpack_public_path__ + "static/media/indels.c0e17fba889223cd3321da8e8f1ccca3.svg";
export { ForwardRef as ReactComponent };